import { Box } from "@mui/material";
// import AutomatedManaged from "./AutomatedManaged";
import VerifiedApplications from "./VerifiedApplications";

const ApplicationOnboardingTab = ({ verifiedApplicationData, onClick }) => {
  return (
    <Box>
      <VerifiedApplications data={verifiedApplicationData} onClick={onClick} />
      {/* <AutomatedManaged /> */}
    </Box>
  );
};

export default ApplicationOnboardingTab;
